import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch, RootState } from '../../redux-stores/store';
import { fetchInvitedCampaignsThunk } from '../../redux-stores/slices/campaignSlice';
import CampaignSkeleton from '../../skeletons/CampaignSkeleton';
import SponsorshipCampaignCard from '../sponsorships/SponsorshipCampaignCard';

import './InvitedCampaigns.scss';

const InvitedCampaignsV2 = () => {
  const { list, loading } = useSelector((state: RootState) => state.campaigns.invited);
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchInvitedCampaignsThunk());
  }, []);

  const hasContent = list.length > 0;
  const title = useMemo(() => 'Inner Circle', []);
  const subtitle = useMemo(() => 'Invitations sent specifically to you.', []);

  if (!hasContent) return null;

  return (
    <>
      {/* <div className="d-flex align-items-center justify-content-center mt-3">
        <svg width="84" height="14" viewBox="0 0 84 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line y1="6.75009" x2="30" y2="6.75009" stroke="#737373" strokeWidth="0.5" />
          <path
            d="M47.1899 7.4876C44.8965 8.1051 43.1051 9.89652 42.4876 12.1899L42.0002 14.0002L41.5128 12.1899C40.8951 9.89652 39.1037 8.1051 36.8103 7.4876L35 7.0002L36.8103 6.5128C39.1037 5.8951 40.8951 4.10367 41.5126 1.81033L42 0L42.4874 1.81033C43.1049 4.10367 44.8963 5.8951 47.1897 6.5126L49 7L47.1899 7.4876Z"
            fill="#737373"
          />
          <line x1="54" y1="6.75009" x2="84" y2="6.75009" stroke="#737373" strokeWidth="0.5" />
        </svg>
      </div> */}
      <div className="invited-campaigns-v2">
        <div className="invited-campaigns-v2__header">
          <div className="invited-campaigns-v2__title">{title}</div>
          <div className="invited-campaigns-v2__subtitle">{subtitle}</div>
        </div>
        <div className="invited-campaigns-v2__section">
          <div className="invited-campaigns-v2__grid-pattern"></div>
          <div className="sponsorship-cards-scroll px-3 py-2">
            {list.map((campaign) => (
              <SponsorshipCampaignCard
                key={campaign.uuid}
                campaign={campaign}
                isInvited={true}
              />
            ))}
          </div>
        </div>
      </div>
    </>

  );
};

export default InvitedCampaignsV2;
